import { render, staticRenderFns } from "./dialog-project-add.vue?vue&type=template&id=2bfa6541&scoped=true"
import script from "./dialog-project-add.vue?vue&type=script&lang=js"
export * from "./dialog-project-add.vue?vue&type=script&lang=js"
import style0 from "./dialog-project-add.vue?vue&type=style&index=0&id=2bfa6541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa6541",
  null
  
)

export default component.exports